export default {
    getInterests(state) {
        return state.interests;
    },
    getNewInterestCount(state) {
        return state.interests.filter(i => i.status === 'NEW').length;
    },
    getHasSubmitted(state) {
        return state.hasSubmitted;
    }
}
